module.exports = __webpack_public_path__ + "static/media/transparencia.7b48ca27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/transparencia.svg
// module id = 194
// module chunks = 0